import axios from "../../axios";
import { parseContentDispositionFilename } from "../../../utils/http";

// CATEGORY 9
const api = {
  getDownstreamTransportationAndDistributionItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${params.questionnaireId}/downstream-transportation-distribution/items`,
      config).then(({ data }) => data);
  },

  addDownstreamTransportationAndDistributionItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/downstream-transportation-distribution/items`,
      data, headers).then(({ data }) => data);
  },

  updateDownstreamTransportationAndDistributionItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/downstream-transportation-distribution/items/${recordId}`,
      data, headers).then(({ data }) => data);
  },

  deleteDownstreamTransportationAndDistributionItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/downstream-transportation-distribution/items/${recordId}`,
      headers).then(({ data }) => data);
  },

  importDownstreamTransportationAndDistributionItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/organization-questionnaires/${questionnaireId}/downstream-transportation-distribution/items/import`,
      data, headers).then(({ data }) => data);
  },

  getDownstreamTransportationAndDistributionTemplate(questionnaireId, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/${questionnaireId}/downstream-transportation-distribution/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = parseContentDispositionFilename(
        headers["content-disposition"], "Scope3_Category9_template.xlsx");
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  }
};

export default api;